export const ttlockConfig = {
  credentials: {
    title: "Konfiguracja TTLock",
    subtitle: "Wprowadź dane logowania do swojego konta TTLock",
    savedBadge: "Dane logowania zapisane",
    noneBadge: "Brak danych logowania",
    emailLabel: "E-mail Twojego konta TTLock",
    emailPlaceholder: "ty@example.com",
    emailHelp: "E-mail używany do logowania w TTLock",
    passwordLabel: "Hasło",
    passwordPlaceholderSaved: "•••••••• (zapisane, zmiana opcjonalna)",
    passwordPlaceholder: "Twoje hasło do TTLock",
    passwordHelpSaved: "Możesz zostawić puste, jeśli hasło jest już zapisane.",
    passwordHelp: "Hasło do Twojego konta TTLock.",
    testing: "Testowanie...",
    testConnection: "Testuj połączenie",
    saving: "Zapisywanie...",
    saveCredentials: "Zapisz dane logowania",
  },
  selector: {
    title: "Wybór zamków dla tego obiektu",
    subtitleBefore: "Wybierz tylko te zamki, które dotyczą ",
    subtitleStrong: "tego obiektu",
    subtitleAfter: ".",
    selectedCount: "{count} wybrany | {count} wybrane | {count} wybranych",
    hintBefore: "Wprowadź dane logowania i naciśnij ",
    hintStrong: "Testuj połączenie",
    hintAfter: ", aby wczytać swoje zamki.",
    noneFound: "Nie znaleziono zamków. Sprawdź swoje konto TTLock.",
    placeholder: "Wybierz zamki…",
    summaryCount: "{count} wybrany zamek | {count} wybrane zamki | {count} wybranych zamków",
    emptySelection: "Nie wybrano żadnego zamka",
    saving: "Zapisywanie...",
    save: "Zapisz zamki dla tego obiektu",
  },
  gateway: {
    with: "Z Gateway",
    without: "Bez Gateway",
  },
  pms: {
    title: "Sterowanie i przypisanie (PMS)",
    subtitleP1: "Przypisz każdy zamek do: ",
    subtitleStrongMain: "Drzwi główne",
    subtitleP2: " lub ",
    subtitleStrongUnit: "Jednostka",
    subtitleP3: ".",
    assignedCount: "{count} przypisany | {count} przypisane | {count} przypisanych",
    empty: "Nie ma jeszcze zapisanych zamków dla tego obiektu.",
    assignmentLabel: "Przypisanie",
    assignmentNone: "Nieprzypisany",
    assignmentCommon: "Drzwi główne (wspólne)",
    assignmentUnit: "Drzwi apartamentu",
    hintNone: "Nie będzie sterowany z poziomu PMS.",
    hintAssigned: "Zostanie powiązany z tym obiektem na potrzeby sterowania i kodów PIN.",
    unitLabel: "Jednostka / Obiekt",
    unitSelectPlaceholder: "Wybierz jednostkę",
    unitHint: "Wskaż, którą jednostkę otwiera ten zamek.",
    nameLabel: "Nazwa (opcjonalnie)",
    namePlaceholder: "np. Drzwi główne / Apt. 101",
    saving: "Zapisywanie...",
    save: "Zapisz przypisanie",
  },
  actions: {
    lock: "Zamknij",
    unlock: "Otwórz",
    requiresGateway: "Wymaga Gateway",
    createPasscode: "Utwórz kod dostępu",
    passcodeHistory: "Historia kodów dostępu",
    refreshStatus: "Odśwież status",
  },
  lockFallbackName: "Zamek {id}",
  unitFallbackName: "Jednostka {id}",
  history: {
    title: "Historia kodów dostępu",
    revocationTitle: "O unieważnianiu kodów:",
    withGatewayLabel: "Z Gateway:",
    withGatewayText: "Kod zostaje unieważniony natychmiast w fizycznym zamku.",
    withoutGatewayLabel: "Bez Gateway:",
    withoutGatewayText:
      "Kod zostaje usunięty z serwera TTLock, ale będzie nadal działać w zamku, dopóki ktoś nie połączy się przez Bluetooth z aplikacji mobilnej i nie zsynchronizuje danych.",
    loading: "Wczytywanie historii…",
    empty: "Brak zapisanych kodów dostępu dla tego zamka.",
    colAlias: "Alias",
    colPasscode: "Kod dostępu",
    colValidity: "Ważność",
    colStatus: "Status",
    createdAt: "Utworzono: {date}",
    fromLabel: "Od:",
    toLabel: "Do:",
    revokedTitle: "Już unieważniony",
    revokeTitle: "Usuń / Unieważnij kod dostępu",
    close: "Zamknij",
  },
  passcodeModal: {
    title: "Utwórz tymczasowy kod dostępu",
    nameLabel: "Nazwa / Etykieta",
    namePlaceholder: "np. Sprzątanie / Gość / Technik",
    nameHint: "Ta nazwa ułatwi rozpoznanie kodu.",
    validFrom: "Ważny od",
    validTo: "Ważny do",
    importantLabel: "Ważne:",
    importantText:
      "Kod zostanie wygenerowany automatycznie przez TTLock i będzie dostępny wyłącznie w podanym okresie. Gość może wpisać ten kod bezpośrednio na klawiaturze zamka (działa bez internetu).",
    noGatewayLabel: "Brak Gateway:",
    noGatewayText:
      "Ten zamek nie ma podłączonego Gateway. Wygenerowane kody będą działać bez zarzutu na fizycznej klawiaturze, ale nie będzie można ich unieważnić zdalnie z tego panelu. Aby unieważnić kod, trzeba to zrobić w aplikacji TTLock, łącząc się przez Bluetooth.",
    cancel: "Anuluj",
    creating: "Tworzenie...",
    create: "Utwórz kod dostępu",
  },
  states: {
    active: "Aktywny",
    upcoming: "Nadchodzący",
    expired: "Wygasły",
    revoked: "Unieważniony",
    noDate: "Brak daty",
  },
  confirm: {
    revoke:
      'Czy na pewno unieważnić/usunąć kod dostępu "{alias}"?\n\nUwaga: jeśli zamek nie ma Gateway, unieważnienie może być tylko częściowe.',
  },
  toast: {
    noLocksFound: "Nie znaleziono zamków w TTLock.",
    loadStatusError: "Nie udało się wczytać statusu zamka",
    loadStatusErrorGeneric: "Błąd podczas wczytywania statusu zamka",
    credentialsRequired: "Trzeba podać nazwę użytkownika i hasło albo mieć zapisane dane logowania.",
    connectionOk:
      "Połączenie udane. Znaleziono {count} urządzenie. | Połączenie udane. Znaleziono {count} urządzenia. | Połączenie udane. Znaleziono {count} urządzeń.",
    testError: "Błąd podczas testowania połączenia",
    credentialsSaved: "Dane logowania zapisane pomyślnie",
    saveCredentialsError: "Błąd podczas zapisywania danych logowania",
    saveCredentialsErrorDetail: "Błąd podczas zapisywania danych logowania: {msg}",
    selectAtLeastOne: "Trzeba wybrać co najmniej jedno urządzenie dla tego obiektu.",
    devicesSaved: "Urządzenia zapisane dla tego obiektu",
    devicesSaveError: "Nie udało się zapisać urządzeń",
    saveErrorDetail: "Błąd podczas zapisywania: {msg}",
    unitRequired: "Wskaż jednostkę dla zamków przypisanych jako 'Drzwi apartamentu'.",
    bindingsSaved: "Przypisanie zapisane pomyślnie",
    bindingsSaveError: "Nie udało się zapisać przypisania",
    bindingsSaveErrorDetail: "Błąd podczas zapisywania przypisania: {msg}",
    assignFirst: "Najpierw przypisz zamek (drzwi główne lub jednostka) i zapisz, aby włączyć sterowanie.",
    passcodeNameRequired: "Trzeba podać nazwę/etykietę kodu dostępu.",
    passcodeDatesRequired: "Trzeba podać datę początku i końca ważności.",
    passcodeCreated: "Kod dostępu utworzony: {code}",
    passcodeCreateError: "Nie udało się utworzyć kodu dostępu",
    passcodeCreateErrorGeneric: "Błąd podczas tworzenia kodu dostępu",
    lockLocked: "Zamek zamknięty",
    lockLockError: "Nie udało się zamknąć",
    lockLockErrorGeneric: "Błąd podczas zamykania",
    lockUnlocked: "Zamek otwarty",
    lockUnlockError: "Nie udało się otworzyć",
    lockUnlockErrorGeneric: "Błąd podczas otwierania",
    revokeNoProviderId: "Ten kod dostępu nie ma provider_passcode_id. Nie można go unieważnić w TTLock.",
    revokedOk: "Kod dostępu całkowicie unieważniony",
    revokeError: "Nie udało się unieważnić",
    revokeErrorGeneric: "Błąd podczas unieważniania kodu dostępu",
    historyLoadError: "Nie udało się wczytać historii",
    historyLoadErrorGeneric: "Błąd podczas wczytywania historii",
  },
};
